// extracted by mini-css-extract-plugin
module.exports = {"truncate-elipsis":"OverflownText_truncate-elipsis__1frAQ"};